//React
import React from "react";
import {
  Link
} from "react-router-dom";
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as communityPostAction from '../action/communityPostAction';
import * as partnerAction from '../action/partnerAction';
import * as lightboxAction from '../action/lightboxAction';
import * as uiAction from '../action/uiAction';
import * as partnerOperationAction from '../action/partnerOperationAction';
//Func
import { lsPostConditionInit, lsPostConditionInitCheck } from '../func/lsPostCondition';
import atom2datetime from '../func/atom2datetime';
//Material-ui
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Fab from '@material-ui/core/Fab';
//Add
import Masonry from 'react-masonry-component';
//Part
import MenuCommunity from './MenuCommunity';
import PartUserMainImg from './PartUserMainImg';
import PartUserName from './PartUserName';
import PartPostGood from './PartPostGood';
import PartPagingNextPrev from './PartPagingNextPrev';
//Dialog
import DialogPostCondition from './DialogPostCondition';
//Icon
import RefreshIcon from '@material-ui/icons/Refresh';
import MoreVertSharpIcon from '@material-ui/icons/MoreVertSharp';
import CreateIcon from '@material-ui/icons/Create';
//img
import Blank from '../img/blank/blank-1x1.gif';
import Blank2x1 from '../img/blank/blank-2x1.gif';

class Comp extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      postConditionVisible: false,
  	}

    if (!localStorage.getItem('PostCondition')) {
      lsPostConditionInit();
    }
  }

  componentDidMount() {
    document.title = 'みんなの投稿 - パートナーズ';
    if ( ((new Date()) - this.props.communityPost.datetime) > (86400*1000) ) {
      this.props.communityPostListGet(this.props.communityPost.page);
    }
    else {
      window.scrollTo(0, this.props.communityPost.scrollpos);
    }
  }

  componentWillUnmount() {
    this.props.communityPostScrollposEdit(window.pageYOffset);
  }

  _onPaging(page) {
    this.props.communityPostListGet(page);
    window.scrollTo(0, 0);
  }


	_renderList = (item, index) => {
		return (
			<div key={item.post_id} className='box_outer'>
				<Box className='box_inner round12' boxShadow={2}>
					<div style={{padding:'2%'}}>

            <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',alignItems:'top'}}>
              <div style={{display:'flex',flexDirection:'row',justifyContent:'start'}}>
                {
                  (item.oppositeSexCheck) && (
                    <div style={{padding:'3px'}}>
                      <Link to={{ pathname: '/partner/' + item.userdata_id_code}}>
                        <PartUserMainImg
                          mainImg={item.userdata_mainImg}
                          width={'50px'}
                          height={'50px'}
                          radius={'50%'}
                        />
                      </Link>
                    </div>
                  )
                }
                <div>
                  <div>
                    {
                      (item.oppositeSexCheck) ? (
                        <Link to={{ pathname: '/partner/' + item.userdata_id_code}}>
                          <PartUserName
                            data={{
                              name: item.userdata_name,
                              sex: item.userdata_sex,
                              size: '1.2em',
                            }}
                          />
                        </Link>
                      ): (
                        <PartUserName
                          data={{
                            name: item.userdata_name,
                            sex: item.userdata_sex,
                            size: '1.2em',
                          }}
                        />
                      )
                    }
                    <span style={{marginLeft:'10px',color:'#222'}}>{item.userdata_age}才 {item.userdata_prof_region}</span>
                  </div>
                  <div style={{color:'#666'}}>{atom2datetime(item.post_date_atom, 'D')}</div>
                </div>
              </div>
              <div>
                <IconButton
                  onClick={ () => this.props.partnerOperationOpen(item.userdata_id_code, ['memo','nondisplay','refusal','breach']) }
                >
                  <MoreVertSharpIcon />
                </IconButton>
              </div>
            </div>

            <div style={{whiteSpace: 'pre-line',color:'#333'}}>
              {item.post_comment}
            </div>

          </div>
          <div>

            {
  						(Array.isArray(item.photo) === true) &&
  						item.photo.map(
  							(value, index, arr) => this._renderImg(value.uri, index, arr)
  						)
  					}

            <div style={{padding:'2%'}}>
              {
                (item.userdata_id_code !== this.props.my.profile.userdata_id_code) ? (
      						<PartPostGood
      							click={ () => this.props.partnerPostGoodEdit(item.userdata_id_code, item.post_id, () => {}) }
      							goodCount={item.good_count}
                    goodCountNondisplay={item.post_good_count_nondisplay}
      						  goodSended={item.post_good_sended}
      						/>
                ): (
                  <PartPostGood
      							click={ () => this.props.snackOpen('error', '自分の投稿に「いいね」はできません', 3000) }
      							goodCount={item.good_count}
                    goodCountNondisplay={item.post_good_count_nondisplay}
      						  goodSended={item.post_good_sended}
      						/>
                )
              }
            </div>
					</div>

				</Box>

			</div>
		);
	};

	_renderImg = (uri, index, arr) => {
    let photoList = arr.map(function(value, index) {
      return {src:arr[index].uri + "&W=600&H=600&blur=0&crop=0"};
    });

		if (((arr.length) % 2) === 1 & index === 0) {
			return (
				<div key={index} style={{display:'inline-block', width:'100%'}}>
					<div
            style={{margin:'1px', position:'relative', cursor:'pointer'}}
            onClick={ () => this.props.lightboxOpen(photoList, index) }
          >

            <img
              src={uri + "&W=600&H=300&blur=0&crop=1"}
              style={{width:"100%", height: "auto", boxSizing:'border-box'}}
              alt=''
            />

            <img
              src={Blank2x1}
              style={{
                position: 'absolute',
                left:0,
                top:0,
                width:'100%',
                height:'100%',
              }}
              alt=''
            />

					</div>
				</div>
			);
		}
		else {
			return (
				<div key={index} style={{display:'inline-block', width:'50%'}}>
          <div
            style={{margin:'1px', position:'relative', cursor:'pointer'}}
            onClick={ () => this.props.lightboxOpen(photoList, index) }
          >
            <img
              src={uri + "&W=300&H=300&blur=0&crop=1"}
              style={{width:"100%", height: "auto", boxSizing:'border-box'}}
              alt=''
            />

            <img
              src={Blank}
              style={{
                position: 'absolute',
                left:0,
                top:0,
                width:'100%',
                height:'100%',
              }}
              alt=''
            />
        	</div>
				</div>
			);
		}
	}


	render() {

		return (
      <div>
        <div style={{maxWidth:'600px', margin:'auto'}}>
          <MenuCommunity />
        </div>


        <div>
          <div
            style={{
              display:'flex',
              flexDirection:'row',
              alignItems:'center',
              justifyContent: 'space-between',
              margin: '10px',
            }}
          >
            <div>
              <Button
                color={ lsPostConditionInitCheck() ? 'primary' : 'secondary' }
                variant={ 'outlined' }
                onClick={ () => this.setState({ postConditionVisible: true}) }
              >
                絞り込む
                {  lsPostConditionInitCheck() ? '' : '(ON)' }
              </Button>
            </div>
            <div>
              <span style={{color:'#666'}}>ページ{this.props.communityPost.page}</span>
              <IconButton
                onClick={ () => this.props.communityPostListGet(1) }
              >
                <RefreshIcon />
              </IconButton>
            </div>
          </div>


          <div id='post_list_block'>
            {
              (this.props.communityPost.datetime) && (
                (this.props.communityPost.list.length > 0) ? (
                  <div>
                    {
                      (this.props.my.proof.credit === 0 && this.props.my.proof.person === 0 && this.props.communityPost.page !== 1) ? (
                        <div  align='center'>
                          <h2 align='center'>本人証明が申請されていない為<br/>これ以上は閲覧できません</h2>
                          <div align='center' style={{padding:'10px'}}>
                            <Button
                              variant="contained"
                              color='secondary'
                              onClick={ () => this.props.history.push('/my/proof/person') }
                            >
                              <div>
                                <div style={{fontSize:'1.4em'}}>本人証明を申請する</div>
                                <div>1分ほどで簡単に登録できます</div>
                              </div>
                            </Button>
                          </div>
                        </div>
                      ) : (
                        <Masonry
                          options={{itemSelector: '.box_outer',transitionDuration: 0,}}
                          disableImagesLoaded={false}
                          updateOnEachImageLoad={true}
                        >
                	        {
                						this.props.communityPost.list.map(
                	          	(value, index) => this._renderList(value, index)
                	        	)
                					}
            				    </Masonry>
                      )
                    }

                    <div style={{margin:'15px'}}>
                      <PartPagingNextPrev
                        page={this.props.communityPost.page}
                        isNext={this.props.communityPost.isListNext}
                        onClick={ (e) => this._onPaging(e) }
                      />
                    </div>


                  </div>
                ) : (
                  <div>
                    <h2 align='center' style={{padding:'30px 0px'}}>
                      <span className='i-b'>投稿が見つかりませんでした</span>
                    </h2>
                    <div align='center'>
                      <Button
                        color="primary"
                        variant={'outlined'}
                        onClick={ () => {
                          lsPostConditionInit();
                          this.props.communityPostListGet(1);
                        }}
                      >
                        条件をリセット
                      </Button>
                    </div>
                  </div>
                )

              )
            }
        	</div>




        </div>

        <div style={{height:'60px'}}></div>

        <div style={{position:'fixed',bottom:'0px',left:'0px',width:'100%', pointerEvents:'none'}}>
          <div style={{maxWidth:'900px', margin:'auto', textAlign:'right', pointerEvents:'none'}}>
            <Fab
              variant="extended"
              color="primary"
              onClick={ () => this.props.history.push('/my/post/') }
              style={{margin:'10px', pointerEvents:'auto'}}
            >
              <CreateIcon />
              &nbsp;
              投稿する
            </Fab>
          </div>
        </div>

        <DialogPostCondition
          open={this.state.postConditionVisible}
          onClose={ () => this.setState({ postConditionVisible: false}) }
        />
      </div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
    my: state.my,
		communityPost: state.communityPost,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
		...communityPostAction,
    ...partnerAction,
    ...lightboxAction,
    ...uiAction,
    ...partnerOperationAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
